import { ReactElement } from 'react';

import { useHirePlanForm } from '../../../../contexts/HirePlanFormProviderGdf';
import { GoForwardButton } from '../../GoForwardButton';

export function ConfirmForm(): ReactElement {
  const { handleSubmit, navigateToProposta } = useHirePlanForm();

  return (
    <form
      action=""
      className="max-w-[766px] w-full"
      onSubmit={handleSubmit(navigateToProposta)}
    >
      <>
        <h2 className="text-[2rem] font-semibold text-center text-primary-main">
          A inclusão foi confirmada com sucesso!
        </h2>
      </>
      <GoForwardButton
        isMobile
        desktopText={'Ir para Proposta'}
        mobileText={'Ir para Proposta'}
      />
    </form>
  );
}
